<template>
  <div class="login-activate-success-view">
    <h1>Cuenta activada</h1>
    <p>Tu cuenta ha sido activada con éxito.</p>
    <router-link
      class="el-button el-button--primary"
      :to="{name:'login'}"
    >
      Ir al login
    </router-link>
  </div>
</template>

<script>
/**
   * 'LoginActivateSuccess.view' Component
   * @version 1.0.0
   * @author Fernando Torres
   * @copyright Marciano Studio S.C., 2018
   */
export default {
  name: 'LoginActivateSuccessView'
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style lang="scss" scoped>
    .login-activate-success-view {

    }
</style>



// WEBPACK FOOTER //
// src/views/login/login-activate-success.view.vue